<script>
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";

export default {
  data() {
    return {
      gameId: undefined,
      typeSource: [
        {
          name: "精细刺激训练",
          type: "FINE_STIMULATION_TRAINING"
        },
        {
          name: "视觉技巧训练",
          type: "VISUAL_SKILL_TRAINING"
        },
        {
          name: "同时视",
          type: "SAME_TIME_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "融合视",
          type: "FUSION_VISION_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "立体视",
          type: "STEREOSCOPIC_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "Gabor训练",
          type: "GABOR_TRAINING"
        },
        {
          name: "对比敏感度训练",
          type: "CONTRAST_SENSITIVITY_TRAINING"
        },
        {
          name: "信息提取训练",
          type: "INFORMATION_EXTRACTION_TRAINING"
        }
      ],
      type: "FINE_STIMULATION_TRAINING",
      games: [],
      needStimulusBackground: undefined,
      layout: undefined,
      activeGame: {}
    };
  },
  watch: {
    type() {
      this.loadData();
    },
    gameId(gameId) {
      if (gameId) {
        let Games = this.games.filter(o => o.id === gameId);
        this.activeGame = Games[0];
        if (this.activeGame.stimulusDemand) {
          this.needStimulusBackground =
            this.activeGame.stimulusDemand.needStimulusBackground || undefined;
          this.layout = this.activeGame.stimulusDemand.layout || undefined;
        } else {
          this.needStimulusBackground = undefined;
          this.layout = undefined;
        }
      }
    }
  },
  created() {
    this.loadData();
    this.getBgs();
  },
  methods: {
    async loadData() {
      const result = await this.$http.getGameList(this.type);
      this.games = result.data ? result.data.content : [];
      if (this.games.length) {
        let Games = this.games.filter(o => o.id === this.gameId);
        let activeGame = this.games[0];
        this.activeGame = this.games[0];
        if (Games.length > 0) {
          activeGame = Games[0];
          this.activeGame = Games[0];
        }

        this.gameId = activeGame.id;
      }
    },

    async onSubmit() {
      // console.log("--->>>>", updateData);
      const updateData = {
        gameId: this.gameId,
        needStimulusBackground: this.needStimulusBackground,
        layout: this.layout
      };
      const result = await this.$http.updateGameLevelManagement(updateData);
      if (result === "success") {
        this.$message.success("保存成功！");
        this.loadData();
      }
    }
  }
};
</script>
<template>
  <div class="stimulusGames">
    <el-card class="box-card cardStyle" shadow="never">
      <div class="configGroup typeGroup">
        <p>训练类别：</p>
        <div>
          <div v-for="typeInfo in typeSource" :key="typeInfo.type + typeInfo.name">
            <el-radio v-model="type" :label="typeInfo.type">{{typeInfo.name}}</el-radio>
          </div>
        </div>
      </div>
      <div class="configGroup gameSelGroup">
        <p>选择游戏：</p>
        <div>
          <el-select size="mini" v-model="gameId">
            <el-option
              v-for="game in games"
              :key="game.id + game.name"
              :label="game.name"
              :value="game.id"
            />
          </el-select>
        </div>
      </div>
    </el-card>
    <div class="parameterView">
      <el-row :gutter="24" class="parameterTitleView">
        <el-col :span="24">
          <span class="parameterTitle">参数配置</span>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="parameterCellView">
        <el-col :span="24" class="parameterCellViewCol">
          <span class="paramsLable">是否使用刺激背景：</span>
          <el-radio-group v-model="needStimulusBackground">
            <el-radio :label="true">使用</el-radio>
            <el-radio :label="false">不使用</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="24" class="parameterCellViewCol">
          <span class="paramsLable">游戏对背景要求：</span>
          <el-radio-group v-model="layout">
            <el-radio label="CENTRAL">中心区域即可</el-radio>
            <el-radio label="TILE">必须满屏平铺</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="24" class="parameterCellViewCol">
          <div class="add-mode">
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.stimulusGames {
  padding-left: 30px;
  padding-top: 15px;

  .cardStyle {
    border: 0px;
    .el-card__body {
      padding: 0px;
    }
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #00c1de;
    background-color: #fff;
  }

  .el-radio__inner::after {
    background-color: #00c1de;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: #00c1de;
  }

  .typeGroup {
    > div {
      display: flex;
      flex-wrap: wrap;
      width: 90%;

      > div {
        width: 157px;
        margin-bottom: 12px;
      }
    }
  }
  .paramsLable {
    display: inline-block;
    line-height: 40px;
    font-size: 14px;
    color: rgba(34, 39, 46, 1);
    width: 140px;
  }
  .configGroup {
    display: flex;
    width: 95%;

    > p {
      // width: 116px;
      flex-shrink: 0;
      margin-right: 16px;
      // text-align: right;
    }

    > div {
      color: #5d5d5d;
      margin-right: 81px;
    }
  }
  .gameSelGroup {
    margin-top: 17px;
    line-height: 32px;
    margin-bottom: 14px;

    > div {
      display: flex;
    }
  }

  .parameterView {
    border: 1px solid #d5dae0;
    border-radius: 4px;
    width: 95%;
    .parameterTitleView {
      margin: 0px !important;
      background-color: #f2f4f6;
      height: 44px;

      .parameterTitle {
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        color: rgba(34, 39, 46, 1);
      }
    }
    .add-mode {
      text-align: center;
    }
    .parameterCellView {
      margin: 0px 0px 10px !important;
      min-height: 140px;
      padding: 10px;
      .parameterCellViewCol {
        margin: 0px 15px 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bgConfig/stimulusGames.vue